export const PAGE = {
  LAUNCH_GAME: 'launchGame',
} as const;
